import { call, put, all, takeLatest } from 'redux-saga/effects';

import { toast } from 'react-toastify';
import { apiGatewayPagamentos } from '~/services/api';

import {
	successLinks,
	failureLinks,
	successGerarLink,
	failureGerarLink,
	successGerarLinkMassa,
	failureGerarLinkMassa,
} from './actions';

function* requestLinks({ payload }) {
	const { params, user } = payload;
	try {
		const resposta = yield call(
			apiGatewayPagamentos.get,
			`v3/billing/list/${params}`, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Basic ${user.dados.gateway_token}`,
			},
		}
		);
		const dados = {
			...resposta.data,
			lista: resposta.data.links ? resposta.data.links : [],
		};

		yield put(successLinks(dados));
	} catch (error) {
		yield put(failureLinks(error.response.status));
	}
}

function* requestGerarLink({ payload }) {
	const { body, user } = payload;

	try {
		const resposta = yield call(
			apiGatewayPagamentos.post,
			`v3/billing/create`, body, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Basic ${user.dados.gateway_token}`,
			},
		});

		yield put(successGerarLink(resposta));
	} catch (error) {
		toast.error(
			`${error.response.status}: Oops algo deu errado, revise os dados e tente novamente`
		);
		yield put(failureGerarLink(error.response.status));
	}
}

function* requestGerarLinkMassa({ payload }) {
	const { body, user } = payload;

	try {
		const resposta = yield call(
			apiGatewayPagamentos.post,
			`v3/billing/bulk-create`,
			body, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Basic ${user.dados.gateway_token}`,
			},
		});

		yield put(successGerarLinkMassa(resposta.data.links_gerados));
	} catch (error) {
		toast.error(
			`${error.response.status}: Oops algo deu errado, revise os dados e tente novamente`
		);
		yield put(failureGerarLinkMassa(error.response.status));
	}
}

export default all([
	takeLatest('@clientMaquinaVirtual/REQUEST_LINKS', requestLinks),
	takeLatest('@clientMaquinaVirtual/REQUEST_GERAR_LINK', requestGerarLink),
	takeLatest(
		'@clientMaquinaVirtual/REQUEST_GERAR_LINK_MASSA',
		requestGerarLinkMassa
	),
]);
